<template>
  <vue-delayed-multiselect-ajax
      :key="`${_uid}-manufactures`"
      :custom-label="customLabel"
      :disabled="disabled"
      :name="name || 'manufacture_id'"
      :params="params"
      :placeholder="$t('Select {something}', { something: $t('manufactures.singular') })"
      :required="required"
      :url="`/v1/manufactures`"
      :value="value"
      v-on="$listeners"
  >
    <template v-slot:beforeList>
      <b-button v-b-modal="`${_uid}-manufacture-create-modal`" variant="link">+
        {{ $t('Add new {something}', {something: $t('manufactures.singular')}) }}
      </b-button>
      <manufacture-create-modal
          :id="`${_uid}-manufacture-create-modal`"
          :key="`${_uid}-manufacture-create-modal-${value}`"
          size="lg"
          @created="onInput($event.id)"
      ></manufacture-create-modal>
    </template>
    <template v-slot:option="{ option }">
      <slot name="option" v-bind="{ option }"></slot>
    </template>
  </vue-delayed-multiselect-ajax>
</template>

<script>
import ManufactureCreateModal from '../modals/manufacture-create';
import VueDelayedMultiselectAjax from "@/components/inputs/vue-delayed-multiselect-ajax.vue";

export default {
  name: 'manufacture-select-ajax',
  components: {
    VueDelayedMultiselectAjax,
    ManufactureCreateModal,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    value: {
      type: Number,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {
          with: 'creator',
        }
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default({ name, short_name }) {
        if (short_name) {
          return `${name} (${short_name})`
        }
        return name
      }
    },
    loaded: {
      type: Function,
      default() {
        return () => {
        };
      }
    }
  },
  methods: {
    onInput(event) {
      if (event === undefined) {
        this.$emit('input', null)
      } else {
        this.$emit('input', event)
      }
    },
    clearAll() {
      this.$emit('input', undefined)
    },
    x() {
      // window.console.log('loaded')
    }
  }
}
</script>

<style scoped>

</style>